import { render, staticRenderFns } from "./DialogAddStartupCost.vue?vue&type=template&id=de2837f6&scoped=true"
import script from "./DialogAddStartupCost.vue?vue&type=script&lang=js"
export * from "./DialogAddStartupCost.vue?vue&type=script&lang=js"
import style0 from "./DialogAddStartupCost.vue?vue&type=style&index=0&id=de2837f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de2837f6",
  null
  
)

export default component.exports